// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st2[data-v-be1727ec] {\n  fill: #1A7BEE;\n}\n.st4[data-v-be1727ec] {\n  fill: #fff;\n}\n.st9[data-v-be1727ec] {\n  fill: #e94766;\n}\n.st27[data-v-be1727ec] {\n  fill: #1c2868;\n}\n", ""]);
// Exports
module.exports = exports;
